import InterfacePRMRJ from "../apiInterface/InterfacePRMRJ";
import ErrorAlert from "@/utility/ErrorAlert";

class DataPrmrj {
  async getDataPrmrj(rm) {
   // let dt: object = {}
   let dt: any;
   await InterfacePRMRJ.getPRMRJbyRM(rm)
     .then(response => {
       dt = response.data;
     })
     .catch(e => {
       dt = e.response
         ErrorAlert.showSnackAlert(e, "RIWAYAT PROFIL RINGKASAN MEDIS RAWAT JALAN")
     });
   return dt;
 }

 async getDataPrmrjByReg(reg,dpjp) {
  // let dt: object = {}
  let dt: any;
  await InterfacePRMRJ.getPRMRJbyReg(reg,dpjp)
    .then(response => {
      dt = response.data;
    })
    .catch(e => {
      dt = e.response
        ErrorAlert.showSnackAlert(e, "PROFIL RINGKASAN MEDIS RAWAT JALAN")
    });
  return dt;
}

  async saveDataPrmrj(
    reg, rm, param
  ) {
    let dt: object = {};
    await InterfacePRMRJ.savePRMRJ(
      reg, rm, param
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }
  async editDataPrmrj(
    id, reg, rm, param
  ) {
    let dt: object = {};
    await InterfacePRMRJ.editPRMRJ(
      id, reg, rm, param
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

}

export default new DataPrmrj();
